import { GROUP_ITEMS_ADD } from '../../actionTypes'

export const add = (payload: any) => {
  return {
    type: GROUP_ITEMS_ADD,
    payload,
  }
}